import React, { useEffect, useState } from 'react';
import { useApi } from '../../../hooks/useApi';
import logger from "../../../utils/logger";
// Списки админки отдаются страницами: забираем все, а не первые 100/1000.
async function loadAllPages(request, path, { pageSize = 200, offsetParam = 'offset' } = {}) {
  const rows = [];
  for (let offset = 0; ; offset += pageSize) {
    const sep = path.includes('?') ? '&' : '?';
    const page = (await request(`${path}${sep}limit=${pageSize}&${offsetParam}=${offset}`)) || [];
    rows.push(...page);
    if (page.length < pageSize) return rows;
  }
}

function AdminSettings() {
  const {
    request,
    showStatus
  } = useApi();
  const [settings, setSettings] = useState(null);
  const [admins, setAdmins] = useState([]);
  const [loading, setLoading] = useState(false);
  const [announcement, setAnnouncement] = useState('');
  const [dailyLimit, setDailyLimit] = useState('0');
  useEffect(() => {
    loadData();
  }, []);
  const canManageSettings = Boolean(settings?.current_user_is_super_admin);
  const loadData = async () => {
    setLoading(true);
    try {
      const [adminSettings, users] = await Promise.all([request('/api/v1/admin/settings'), loadAllPages(request, '/api/v1/users/', { pageSize: 1000, offsetParam: 'skip' })]);
      setSettings(adminSettings);
      setAnnouncement(adminSettings?.system_announcement || '');
      setDailyLimit(String(adminSettings?.ai_chat_daily_message_limit ?? 0));
      setAdmins((users || []).filter(user => user.role === 'admin'));
    } catch (error) {
      logger.error(error);
      showStatus('error', 'Не удалось загрузить системные настройки.');
    } finally {
      setLoading(false);
    }
  };
  const updateSettings = async (payload, successMessage) => {
    try {
      const response = await request('/api/v1/admin/settings', {
        method: 'POST',
        body: JSON.stringify(payload)
      });
      const nextSettings = {
        ...settings,
        ...(response?.settings || {})
      };
      setSettings(nextSettings);
      if (typeof nextSettings.system_announcement === 'string') {
        setAnnouncement(nextSettings.system_announcement);
      }
      if (nextSettings.ai_chat_daily_message_limit !== undefined) {
        setDailyLimit(String(nextSettings.ai_chat_daily_message_limit));
      }
      if (successMessage) {
        showStatus('success', successMessage);
      }
    } catch (error) {
      logger.error(error);
      showStatus('error', 'Не удалось сохранить системные настройки.');
    }
  };
  const handlePromote = async email => {
    if (!email) return;
    try {
      const allUsers = await loadAllPages(request, '/api/v1/users/', { pageSize: 1000, offsetParam: 'skip' });
      const target = allUsers.find(user => user.email === email);
      if (!target) {
        showStatus('error', 'Пользователь не найден.');
        return;
      }
      await request(`/api/v1/admin/users/${target.id}/make-admin`, {
        method: 'POST'
      });
      showStatus('success', 'Права администратора выданы.');
      await loadData();
    } catch (error) {
      logger.error(error);
      showStatus('error', 'Не удалось выдать права администратора.');
    }
  };
  const handleDemote = async admin => {
    if (!window.confirm(`Снять права администратора с ${admin.email}?`)) return;
    try {
      await request(`/api/v1/admin/users/${admin.id}/remove-admin`, {
        method: 'POST'
      });
      showStatus('success', 'Права администратора сняты.');
      await loadData();
    } catch (error) {
      logger.error(error);
      showStatus('error', error.message || 'Не удалось снять права администратора.');
    }
  };
  return <div className="admin-page">
            <h1 style={{
      marginBottom: '5px'
    }}>Системные настройки</h1>
            <p style={{
      color: '#666',
      marginBottom: '30px'
    }}>
                Управление платформой, администраторами и доступностью модулей.
            </p>

            {loading && !settings && <div>Загрузка...</div>}

            <div style={{
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: '30px',
      alignItems: 'start'
    }}>
                <div style={{
        background: 'white',
        padding: '25px',
        borderRadius: '12px',
        boxShadow: '0 4px 6px rgba(0,0,0,0.05)'
      }}>
                    <h3 style={{
          marginTop: 0
        }}>Система</h3>
                    <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '15px'
        }}>
                        <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            padding: '10px',
            background: '#f8f9fa',
            borderRadius: '6px',
            alignItems: 'center'
          }}>
                            <span>Режим обслуживания</span>
                            <button type="button" disabled={!canManageSettings} onClick={() => updateSettings({
              maintenance_mode: !settings?.maintenance_mode
            }, 'Режим обслуживания обновлен.')} style={{
              padding: '5px 15px',
              background: settings?.maintenance_mode ? '#e74c3c' : '#27ae60',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: canManageSettings ? 'pointer' : 'not-allowed',
              opacity: canManageSettings ? 1 : 0.6
            }}>
                
                                {settings?.maintenance_mode ? 'Включен' : 'Выключен'}
                            </button>
                        </div>

                        <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '8px',
            padding: '10px',
            background: '#f8f9fa',
            borderRadius: '6px'
          }}>
                            <span>Объявление для всех пользователей</span>
                            <div style={{
              display: 'flex',
              gap: '8px'
            }}>
                                <input type="text" value={announcement} onChange={event => setAnnouncement(event.target.value)} placeholder="Текст объявления..." style={{
                flex: 1,
                padding: '8px',
                border: '1px solid #ddd',
                borderRadius: '4px'
              }} />
                
                                <button type="button" disabled={!canManageSettings} onClick={() => updateSettings({
                system_announcement: announcement
              }, 'Объявление обновлено.')} style={{
                padding: '8px 12px',
                background: '#3498db',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: canManageSettings ? 'pointer' : 'not-allowed',
                opacity: canManageSettings ? 1 : 0.6
              }}>
                  
                                    Сохранить
                                </button>
                            </div>
                        </div>

                        <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '8px',
            padding: '10px',
            background: '#f8f9fa',
            borderRadius: '6px'
          }}>
                            <span>Лимит сообщений в AI-чате на пользователя в сутки</span>
                            <div style={{
              display: 'flex',
              gap: '8px',
              alignItems: 'center'
            }}>
                                <input type="number" min="0" value={dailyLimit} onChange={event => setDailyLimit(event.target.value)} style={{
                width: '120px',
                padding: '8px',
                border: '1px solid #ddd',
                borderRadius: '4px'
              }} />
                                <button type="button" disabled={!canManageSettings} onClick={() => updateSettings({
                ai_chat_daily_message_limit: Number(dailyLimit) || 0
              }, 'Лимит сообщений обновлён.')} style={{
                padding: '8px 12px',
                background: '#3498db',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: canManageSettings ? 'pointer' : 'not-allowed',
                opacity: canManageSettings ? 1 : 0.6
              }}>
                                    Сохранить
                                </button>
                            </div>
                            <span style={{ fontSize: '12px', color: '#999' }}>
                                0 = без ограничений. При достижении лимита чат вежливо предложит вернуться завтра, без ошибок и блокировки других разделов.
                            </span>
                        </div>

                        <div style={{
            padding: '10px',
            background: '#f8f9fa',
            borderRadius: '6px'
          }}>
                            <strong>Права на изменение:</strong>{' '}
                            {canManageSettings ? 'суперадмин' : 'только чтение'}
                        </div>
                    </div>
                </div>

                <div style={{
        background: 'white',
        padding: '25px',
        borderRadius: '12px',
        boxShadow: '0 4px 6px rgba(0,0,0,0.05)'
      }}>
                    <h3 style={{
          marginTop: 0
        }}>Администраторы</h3>

                    {canManageSettings && <div style={{
          marginBottom: '20px',
          display: 'flex',
          gap: '10px'
        }}>
                            <input id="newAdminEmail" type="email" placeholder="admin@anylex.ru" style={{
            flex: 1,
            padding: '10px',
            border: '1px solid #ddd',
            borderRadius: '4px'
          }} />
            
                            <button type="button" onClick={() => handlePromote(document.getElementById('newAdminEmail')?.value || '')} style={{
            padding: '10px 15px',
            background: '#27ae60',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer'
          }}>
              
                                Назначить
                            </button>
                        </div>}

                    <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '10px'
        }}>
                        {admins.map(admin => <div key={admin.id} style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '10px',
            borderBottom: '1px solid #eee'
          }}>
                                <div>
                                    <div style={{
                fontWeight: 'bold'
              }}>{admin.email}</div>
                                    <div style={{
                fontSize: '12px',
                color: '#999'
              }}>{admin.first_name} {admin.last_name}</div>
                                </div>
                                <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '10px'
            }}>
                                    <span style={{
                fontSize: '12px',
                background: '#34495e',
                color: 'white',
                padding: '2px 6px',
                borderRadius: '4px'
              }}>
                                        {admin.admin_permissions?.includes('all') ? 'SUPER' : 'ADMIN'}
                                    </span>
                                    {canManageSettings && !admin.admin_permissions?.includes('all') && <button type="button" onClick={() => handleDemote(admin)} style={{
                background: 'none',
                border: 'none',
                color: '#e74c3c',
                cursor: 'pointer',
                fontSize: '12px'
              }}>
                                        Снять права
                                    </button>}
                                </div>
                            </div>)}
                    </div>
                </div>
            </div>

        </div>;
}
export default AdminSettings;
